import React from "react";
import { useSelector, useDispatch } from "react-redux";

export const TodoComp = () => {
  const todos = useSelector((state) => state.todo);
  const dispatch = useDispatch();

  const [name, setName] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: "ADD-TODO", payload: { name: name } });
    setName("");
  };

  return (
    <div style={{ margin: "1rem" }}>
      <h3>ToDo Component:</h3>
      <h6> A todo component constructed based on the Redux.</h6>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex" }}>
          <input
            className="form-control"
            type="text"
            value={name}
            style={{ margin: "auto", width: "100%" }}
            onChange={(e) => setName(e.target.value)}
          />

          <button
            style={{
              backgroundColor: "royalblue",
              margin: "0.2rem",
              padding: "0.3rem",
              borderRadius: "0.5rem",
              color: "white",
              outline: "none",
            }}
            onClick={handleSubmit}
          >
            Add
          </button>
        </div>
      </form>
      {todos.map((todo) => {
        return <Todo key={todo.id} todo={todo} dispatch={dispatch} />;
      })}
    </div>
  );
};

const Todo = ({ todo, dispatch }) => {
  return (
    <>
      <div>
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-6">
            <span style={{ color: todo.complete ? "#AAA" : "#000" }}>
              {todo.name}
            </span>
          </div>
          <div className="col-md-3">
            <button
              style={{
                backgroundColor: "royalblue",
                margin: "0.2rem",
                padding: "0.3rem",
                borderRadius: "0.5rem",
                color: "white",
                outline: "none",
              }}
              className="btn btn-primary"
              onClick={() => dispatch({ type: "TOGGLE-TODO", payload: todo })}
            >
              Toggle
            </button>
          </div>
          <div className="col-md-3">
            <button
              style={{
                margin: "0.2rem",
                padding: "0.3rem",
                borderRadius: "0.5rem",
                color: "white",
                outline: "none",
              }}
              className="btn btn-danger"
              onClick={() => dispatch({ type: "REMOVE-TODO", payload: todo })}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
